<template>
    <a-select
            showSearch
            v-model="model"
            :placeholder="placeholder"
            :defaultActiveFirstOption="false"
            :filterOption="false"
            @search="handleSearch"
            @change="handleChange"
            @select="onSelect"
            :notFoundContent="null"
    >
        <a-select-option v-for="(option,index) in options" :key="option.id"  :value="option" >{{option.name}}({{option.num}}) {{option.sex|sex}}</a-select-option>
    </a-select>
</template>
<script>
    import { getOptions} from '@/api/yundongyuan';
    export default {
    name: 'YundongyuanPicker',
    data () {
      return {
        model:undefined,
          options:[]
      }
    },
    props: {
        placeholder:{
            type: String,
            default:'请选择运动员'
        },
        user_id:{
            type: Number,
            default:0
        },
        danwei_id:{
            type: Number,
            default:0
        },
    },
    computed:{
    },
        filters:{
        sex(val){
            if(val == 1){
                return '男'
            }else if(val==2){
                return '女'
            }else{
                return '未知'
            }
        }

        },
      watch: {
      },
      created(){
      },
    methods: {
        handleSearch(value){
            let that = this;
            getOptions({ keywords: value  ,user_id:that.user_id,danwei_id: that.danwei_id}).then(res => {
                that.options = res.data
            })
       },
        handleChange(value){
//            this.formData[this.field] = value;
            console.log('picker- handleChange',value);
            this.$emit("onChange", value);
       },
        onSelect(value,option){
//            this.formData[this.field] = value;
            console.log('picker- onSelect',value);
            this.$emit("onSelect", value);
       }
    },
  }
</script>
<style>

</style>